import { UNITARY_SHIFT } from '@/utils/constants'
import { questionsConfig } from '@/utils/questions'

export function validateMaxAnswers(currentValue, questionIndex, groupQuestions) {
  let maxValue = 0

  const currentMinValue = groupQuestions[questionIndex].advancedOptions.min_answers

  const answerLength = groupQuestions[questionIndex].answers.length

  const questionArrayFilter = groupQuestions[questionIndex].advancedOptions.array_filter

  const questionArrayFilterReverse =
    groupQuestions[questionIndex].advancedOptions.array_filter_reverse

  const questionArrayFilterReferenced =
    questionArrayFilter && groupQuestions.find(({ code }) => code === questionArrayFilter)

  const questionArrayFilterReverseReferenced =
    questionArrayFilterReverse &&
    groupQuestions.find(({ code }) => code === questionArrayFilterReverse)

  const hasExclusiveAnswer = groupQuestions[questionIndex].answers.some(
    ({ exclusive }) => exclusive,
  )

  if (questionArrayFilterReferenced) {
    if (currentValue > questionArrayFilterReferenced.advancedOptions?.max_answers) {
      maxValue = questionArrayFilterReferenced.advancedOptions.max_answers
    } else {
      if (hasExclusiveAnswer && currentValue > answerLength) {
        maxValue = answerLength
      } else if (currentValue < 0) {
        maxValue = 0
      } else if (hasExclusiveAnswer && currentValue < currentMinValue) {
        maxValue = currentMinValue
      } else if (currentValue > answerLength) {
        maxValue = answerLength
      } else if (currentValue < currentMinValue) {
        maxValue = currentMinValue
      } else if (currentValue === '') {
        maxValue = ''
      }
    }
  } else if (currentValue > questionArrayFilterReverseReferenced?.answers?.length) {
    maxValue = questionArrayFilterReverseReferenced.answers.length
  } else if (currentValue < 0) {
    maxValue = 0
  } else if (hasExclusiveAnswer && currentValue > answerLength) {
    maxValue = answerLength
  } else if (hasExclusiveAnswer && currentValue < currentMinValue) {
    maxValue = currentMinValue
  } else if (currentValue > answerLength) {
    maxValue = answerLength
  } else if (currentValue < currentMinValue) {
    maxValue = currentMinValue
  } else if (currentValue === '') {
    maxValue = ''
  }

  return maxValue
}

function validateMinAnswersArrayFilter(currentValue, questionArrayFilterReferenced) {
  let minValue = 0

  const questionArrayFilterAnswersLength = questionArrayFilterReferenced?.answers.length

  if (currentValue > questionArrayFilterAnswersLength) {
    minValue = questionArrayFilterReferenced?.answers.length
  }

  const exclusivesAnswersArrayFilter = questionArrayFilterReferenced?.answers.filter(
    answer => answer?.exclusive,
  )

  if (exclusivesAnswersArrayFilter) {
    const answersNotExclusive =
      questionArrayFilterAnswersLength - exclusivesAnswersArrayFilter.length

    if (currentValue > answersNotExclusive) {
      minValue = answersNotExclusive
    }
  }

  return minValue
}

function validateMinAnswersArrayFilterReverse(
  currentValue,
  questionArrayFilterReverseReferenced,
) {
  let minValue = 0

  const questionArrayFilterReverseAnswersLength =
    questionArrayFilterReverseReferenced?.answers.length

  if (currentValue > questionArrayFilterReverseReferenced?.answers.length) {
    minValue = questionArrayFilterReverseReferenced.answers.length
  }

  const exclusivesAnswersArrayFilterReverse = questionArrayFilterReverseReferenced?.answers.filter(
    answer => answer?.exclusive,
  )

  if (exclusivesAnswersArrayFilterReverse) {
    const answersNotExclusive =
      questionArrayFilterReverseAnswersLength - exclusivesAnswersArrayFilterReverse.length

    if (currentValue > answersNotExclusive) {
      minValue = answersNotExclusive
    }
  }

  return minValue
}

export function validateMinAnswers(currentValue, questionIndex, groupQuestions) {
  let minValue = 0

  const answersLength = groupQuestions[questionIndex].answers.length

  const currentMaxValue = groupQuestions[questionIndex].advancedOptions.max_answers

  const questionArrayFilter = groupQuestions[questionIndex].advancedOptions.array_filter

  const questionArrayFilterReverse =
    groupQuestions[questionIndex].advancedOptions.array_filter_reverse

  const exclusivesAnswers = groupQuestions[questionIndex].answers.filter(
    answer => answer?.exclusive,
  )

  if (currentValue > answersLength) minValue = answersLength

  if (currentValue > currentMaxValue) minValue = currentMaxValue

  if (exclusivesAnswers) {
    const answersNotExclusive = answersLength - exclusivesAnswers.length

    if (currentValue > answersNotExclusive) {
      minValue = answersNotExclusive
    }
  }

  const questionArrayFilterReferenced =
    questionArrayFilter && groupQuestions.find(({ code }) => code === questionArrayFilter)

  if (questionArrayFilterReferenced) {
    minValue = validateMinAnswersArrayFilter(currentValue, questionArrayFilterReferenced)
  }

  const questionArrayFilterReverseReferenced =
    questionArrayFilterReverse &&
    groupQuestions.find(({ code }) => code === questionArrayFilterReverse)

  if (questionArrayFilterReverseReferenced) {
    minValue = validateMinAnswersArrayFilterReverse(
      currentValue,
      questionArrayFilterReverseReferenced,
    )
  }

  return minValue
}

export function validateMaxSlider(currentValue, questionIndex, groupQuestions) {
  let maxSliderValue = 0

  const currentMinSliderValue = groupQuestions[questionIndex].advancedOptions.slider_min

  if (currentValue <= currentMinSliderValue) {
    maxSliderValue = currentMinSliderValue + UNITARY_SHIFT
  }

  return maxSliderValue
}

export function validateMinSlider(currentValue, questionIndex, groupQuestions) {
  let minSliderValue = currentValue

  const currentMaxSliderValue = groupQuestions[questionIndex].advancedOptions.slider_max

  if (currentValue >= currentMaxSliderValue && currentMaxSliderValue) {
    minSliderValue = currentMaxSliderValue - UNITARY_SHIFT
  }

  return minSliderValue
}

export function validateSliderAccuracy(currentValue, questionIndex, groupQuestions) {
  let sliderAccuracyValue = 0

  const currentMaxSliderValue = groupQuestions[questionIndex].advancedOptions.slider_max

  if (currentValue <= 0) {
    sliderAccuracyValue = 1
  } else if (currentValue > currentMaxSliderValue) {
    sliderAccuracyValue = currentMaxSliderValue
  }

  return sliderAccuracyValue
}

export function validateMaxSumOfValuesEqualsTo(
  currentValue,
  questionIndex,
  groupQuestions,
) {
  let maxSumValue = 0

  const answersLength = groupQuestions[questionIndex].answers.length

  const questionType = groupQuestions[questionIndex].type

  const advancedOptions = questionsConfig[questionType].advancedOptions

  const advancedOption =
    'slider_max' in advancedOptions ? 'slider_max' : 'max_num_value_n'

  const maxValue = groupQuestions[questionIndex].advancedOptions[advancedOption]

  const totalMaxSum = maxValue * answersLength

  const currentMinSumValues = groupQuestions[questionIndex].advancedOptions?.min_sum

  if (currentValue <= currentMinSumValues && currentMinSumValues) {
    maxSumValue = currentMinSumValues + UNITARY_SHIFT
  } else {
    if (currentValue > totalMaxSum) maxSumValue = totalMaxSum
    else if (currentValue < 0) maxSumValue = 1
  }

  return maxSumValue
}

export function validateMinSumOfEqualsTo(currentValue, questionIndex, groupQuestions) {
  if (currentValue === '' || currentValue < 0) return ''
  let minSumValue = 0

  const currentMaxSumValues = groupQuestions[questionIndex].advancedOptions.max_sum

  if (currentValue >= currentMaxSumValues && currentMaxSumValues) {
    minSumValue = currentMaxSumValues - UNITARY_SHIFT
  }

  return minSumValue
}

export function validateSumEqual(currentValue, questionIndex, groupQuestions) {
  let sumEqualValue = 0

  const answersLength = groupQuestions[questionIndex]?.answers.length

  const questionType = groupQuestions[questionIndex].type

  const advancedOptions = questionsConfig[questionType].advancedOptions

  const advancedOption =
    'slider_max' in advancedOptions ? 'slider_max' : 'max_num_value_n'

  const maxValue = groupQuestions[questionIndex].advancedOptions[advancedOption]

  const totalSumValues = maxValue * answersLength

  if (currentValue >= totalSumValues) {
    sumEqualValue = totalSumValues
  } else if (currentValue < 0) {
    sumEqualValue = 1
  }

  return sumEqualValue
}

export function validateDisplayColumns(currentValue) {
  if (currentValue === '' || currentValue < 1) return ''
}

export function validateMaximumChars(currentValue, questionIndex, groupQuestions) {
  if (currentValue === '' || currentValue < 1) return ''

  let maxChars = 0

  const currentMinChars = groupQuestions[questionIndex].advancedOptions?.minimum_chars

  if (currentValue <= currentMinChars && currentMinChars) {
    maxChars = currentMinChars + UNITARY_SHIFT
  }

  return maxChars
}

export function validateMinimumChars(currentValue, questionIndex, groupQuestions) {
  if (currentValue === '' || currentValue < 0) return ''

  let minChars = 0

  const currentMaxChars = groupQuestions[questionIndex].advancedOptions?.maximum_chars

  if (currentValue >= currentMaxChars && currentMaxChars) {
    minChars = currentMaxChars - UNITARY_SHIFT
  }

  return minChars
}

export function validateMaxNumber(currentValue, questionIndex, groupQuestions) {
  if (currentValue === '') return ''

  let maxNumber = currentValue

  const currentMinNumber = groupQuestions[questionIndex].advancedOptions?.min_num_value_n

  if (maxNumber <= currentMinNumber) {
    maxNumber = currentMinNumber + UNITARY_SHIFT
  }

  return maxNumber
}

export function validateMinNumber(currentValue, questionIndex, groupQuestions) {
  if (currentValue === '' || currentValue < 0) return ''

  let minNumber = currentValue

  const currentMaxNumber = groupQuestions[questionIndex].advancedOptions?.max_num_value_n

  if (currentValue >= currentMaxNumber && currentMaxNumber) {
    minNumber = currentMaxNumber - UNITARY_SHIFT
  }

  return minNumber
}

export function validateMaximumWordCount(currentValue, questionIndex, groupQuestions) {
  if (currentValue === '' || currentValue < 1) return ''

  let maxWordCount = 0

  const currentMinChars =
    groupQuestions[questionIndex].advancedOptions?.minimum_word_count

  if (currentValue <= currentMinChars && currentMinChars) {
    maxWordCount = currentMinChars + UNITARY_SHIFT
  }

  return maxWordCount
}

export function validateMinimumWordCount(currentValue, questionIndex, groupQuestions) {
  if (currentValue === '' || currentValue < 0) return ''

  let minWordCount = 0

  const currentMaxChars =
    groupQuestions[questionIndex].advancedOptions?.maximum_word_count

  if (currentValue >= currentMaxChars && currentMaxChars) {
    minWordCount = currentMaxChars - UNITARY_SHIFT
  }

  return minWordCount
}
